/** `divespots.passkeyOffer.<userId>`: the account page's "set up a passkey?" offer, dismissed per viewer. */
const KEY = "divespots.passkeyOffer";

export const offerDismissed = (userId: string): boolean => {
  try {
    return localStorage.getItem(`${KEY}.${userId}`) === "1";
  } catch {
    return false;
  }
};

export const dismissOffer = (userId: string): void => {
  try {
    localStorage.setItem(`${KEY}.${userId}`, "1");
  } catch {
    /* not remembered */
  }
};
